import React from "react";
import {BaseFragment, BaseFragmentProps, BaseFragmentState} from "../shared/BaseFragment";
import {StyledBoxColumn, StyledBoxRow} from "../shared/StyledComponents";
import {Button, Typography} from "@mui/material";

export enum PuppetType {
  M01 = "m01",
  F01 = "f01",
  B01 = "b01",
  G01 = "g01",
}

export class Puppet {

  constructor(readonly type: PuppetType) {
  }
}

const PUPPETS = new Map<PuppetType, Puppet>([
  [PuppetType.M01, new Puppet(PuppetType.M01)],
  [PuppetType.F01, new Puppet(PuppetType.F01)],
  [PuppetType.G01, new Puppet(PuppetType.G01)],
  [PuppetType.B01, new Puppet(PuppetType.B01)],
]);

export interface StartFragmentListener {
  onPuppetChosen(puppet: Puppet);

  onCreatePuppet();
}

export type StartFragmentProps = BaseFragmentProps & {
  listener: StartFragmentListener,
}

type StartFragmentState = BaseFragmentState & {}

export class StartFragment extends BaseFragment<StartFragmentProps, StartFragmentState> {

  protected renderContainerContent(): React.ReactElement | null {
    return <StyledBoxRow style={{flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
      <StyledBoxColumn style={{alignItems: "center", gap: 48}}>
        <Typography variant="h5">Choose a puppet to start</Typography>
        <StyledBoxRow style={{gap: 48}}>
          <Button onClick={() => this.props.listener.onPuppetChosen(PUPPETS.get(PuppetType.B01))}>
            <img src={"/assets/puppets/skeletons/b01-skeleton-front.svg"} style={{width: 160, aspectRatio: .48}}/>
          </Button>
          <Button onClick={() => this.props.listener.onPuppetChosen(PUPPETS.get(PuppetType.G01))}>
            <img src={"/assets/puppets/skeletons/g01-skeleton-front.svg"} style={{width: 160, aspectRatio: .48}}/>
          </Button>
        </StyledBoxRow>
        <Typography>OR</Typography>
        <Button variant="contained" onClick={() => this.props.listener.onCreatePuppet()}>Create a new puppet</Button>
      </StyledBoxColumn>
    </StyledBoxRow>
  }
}